export default "__VITE_ASSET__D1JRF7Nc__"